import * as ScrollArea from "@radix-ui/react-scroll-area";
import * as styles from "./Scrollable.style.tsx";
import type { PropsWithChildren, RefAttributes } from "react";
import type { ScrollAreaProps } from "@radix-ui/react-scroll-area";
import type { Interpolation } from "@emotion/styled";
import type { Theme } from "@emotion/react";

type ScrollableProps = PropsWithChildren<
  RefAttributes<HTMLDivElement> &
    ScrollAreaProps & {
      disableHorizontal?: boolean;
      disableVertical?: boolean;
      css?: Interpolation<Theme>;
    }
>;

export const Scrollable = ({
  children,
  css,
  type = "scroll",
  disableHorizontal = false,
  disableVertical = false,
  ...rest
}: ScrollableProps) => {
  return (
    <ScrollArea.Root css={[styles.root, css]} type={type} {...rest}>
      <ScrollArea.Viewport css={styles.viewport}>
        {children}
      </ScrollArea.Viewport>
      {!disableHorizontal && (
        <ScrollArea.Scrollbar css={styles.scrollbar} orientation="horizontal">
          <ScrollArea.Thumb css={styles.thumb} />
        </ScrollArea.Scrollbar>
      )}
      {!disableVertical && (
        <ScrollArea.Scrollbar css={styles.scrollbar} orientation="vertical">
          <ScrollArea.Thumb css={styles.thumb} />
        </ScrollArea.Scrollbar>
      )}

      <ScrollArea.Corner css={styles.corner} />
    </ScrollArea.Root>
  );
};
